module.exports = __webpack_public_path__ + "static/media/Comp 1.d6d9bda8.gif";